import type { Reactive } from "vue";
import type { Requests } from "../common/request.common";
import type { NetworkUsageResponseTypes } from "../common/response.common";
import { get, post } from "./common";

export const networkUsage = {
    record(groupId?: string) {
        return (data: typeof Requests.NetworkUsage.Record.Input) => {
            return post<typeof data, NetworkUsageResponseTypes.Record>(
                `/network-usage/record/${groupId ?? ""}`,
                data,
            );
        };
    },
    create(data: typeof Requests.NetworkUsage.Create.Input) {
        return post<typeof data>(`/network-usage/create`, data);
    },
    obtain(id: string) {
        return get<NetworkUsageResponseTypes.Obtain>(`/network-usage/obtain/${id}`);
    },
    formHooks: {
        select(groupId: Reactive<string> | undefined, current?: string) {
            return async () => {
                if (groupId === undefined) return [];
                const q = current !== undefined ? `?current=${current}` : "";
                return (await get(`/network-usage/select/${groupId}${q}`).execute()) ?? [];
            };
        },
    },
};
